import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  Stack,
  FormControl
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Box, Container } from "@mui/material";
import { Formik, Form } from "formik";
import { useDispatch } from "react-redux";
import { outputSubmissionUpload } from "../../core/service/outputSubmission.service";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import OutputSubmissionPageInfo from "./Form/OutputSubmissionPageInfo";
import OutputSubmissionPage1 from "./Form/OutputSubmissionPage1";

import validationSchema from "./FormModel/validationSchema";
import outputSubmissionModel from "./FormModel/outputSubmissionModel";
import formInitialValues from "./FormModel/formInitialValues";

const steps = ["Page1", "Pag2"];
const { formId, formField } = outputSubmissionModel;

function _renderStepContent(step) {
  const navigate = useNavigate();
  switch (step) {
    case 0:
      return <OutputSubmissionPageInfo formField={formField} />;
    case 1:
      return <OutputSubmissionPage1 formField={formField} />;
    default:
      return () =>
        navigate(`/404`, {
          replace: true
        });
  }
}

export default function OutputSubmission() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const currentValidationSchema = validationSchema[activeStep];
  const isLastStep = activeStep === steps.length - 1;

  const { role } = useSelector((state) => state.authReducer);
  const { user: currentUser } = useSelector((state) => state.authReducer);

  function _sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function _submitForm(values, actions) {
    var formData = new FormData();

    for (const [key, value] of Object.entries(values)) {
      if (Array.isArray(value)) {
        value.forEach((e, i) => {
          for (const [k, v] of Object.entries(e)) {
            if (v?.file) {
              formData.append(k, v.file);
            }
          }
        });
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value ? value : "");
      }
    }
    formData.append("role", role);
    formData.append("user_id", currentUser.id);

    await outputSubmissionUpload(formData);
    await _sleep(1000);
    actions.setSubmitting(false);
    // setActiveStep(activeStep + 1);
  }

  const successSubmit = () => {
    Swal.fire({
      icon: "success",
      title: "Successfully",
      showConfirmButton: false,
      timer: 1500
    }).then((result) =>
      navigate(`/research-progress/${role}`, { replace: true })
    );
  };

  async function _handleSubmit(values, actions) {
    if (isLastStep) {
      await _submitForm(values, actions);
      successSubmit();
    } else {
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  }

  function _handleBack() {
    setActiveStep(activeStep - 1);
  }

  return (
    <Container>
      <Box>
        <>
          <Typography component="h1" variant="h4">
            Output Submission for C2F PhD Scholarship
          </Typography>
          <FormControl>
            <Stepper activeStep={activeStep} sx={{ paddingTop: 6 }}>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </FormControl>
          <>
            {/* {activeStep === steps.length ? (
              <>SS</>
            ) : ( */}
            <Formik
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}
            >
              {({ isSubmitting }) => {
                return (
                  <Form id={formId}>
                    <Box sx={{ paddingTop: 6, paddingBottom: 6 }}>
                      {_renderStepContent(activeStep)}
                    </Box>

                    <Stack
                      direction="row"
                      justifyContent="space-evenly"
                      alignItems="center"
                      spacing={12}
                      sx={{ paddingTop: 3 }}
                    >
                      {activeStep !== 0 && (
                        <Button
                          size="large"
                          variant="contained"
                          onClick={_handleBack}
                        >
                          Back
                        </Button>
                      )}
                      {activeStep === 0 && (
                        <Button
                          size="large"
                          variant="contained"
                          onClick={()=>{
                            navigate(`/research-progress/${role}`, { replace: true })
                          }}
                          //href={`/research-progress/${role}`}
                        >
                          Cancel
                        </Button>
                      )}
                      <LoadingButton
                        loading={isSubmitting}
                        size="large"
                        disabled={isSubmitting}
                        type="submit"
                        variant="contained"
                        color="primary"
                      >
                        {isLastStep ? "Submit" : "Next"}
                      </LoadingButton>
                    </Stack>
                  </Form>
                );
              }}
            </Formik>
            {/* )} */}
          </>
        </>
      </Box>
    </Container>
  );
}
